import { useEffect, useRef } from "react";
import { useLivekitContext } from "../../VideoProvider/LivekitProvider";

class Track {
  _attachments: HTMLVideoElement[] = [];

  attach(element: HTMLVideoElement) {
    this._attachments.push(element);
  }

  detach(element: HTMLVideoElement) {
    this._attachments = this._attachments.filter(
      attachment => attachment !== element,
    );
  }
}

export const useLivekitScreenShareVideo = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const videoElement = videoRef.current;
  const { screenSharingParticipant: peer } = useLivekitContext();
  const screenSharePublication = {
    isSubscribed: true,
    track: new Track(),
    isMuted: false,
  };
  const track = screenSharePublication?.track;
  const hasVideo =
    screenSharePublication?.isSubscribed &&
    screenSharePublication?.track &&
    !screenSharePublication?.isMuted;

  useEffect(() => {
    if (videoElement && track) {
      track.attach(videoElement);
    }

    return () => {
      if (videoElement && track) {
        track.detach(videoElement);
      }
    };
  }, [videoElement, track]);

  return {
    peer,
    videoRef,
    hasVideo,
    shouldWarnInfinityMirror: false,
  };
};
